import React, { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const Timeline = ({ data, title }) => {
    const ref = useRef(null);
    const containerRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (ref.current) {
            setHeight(ref.current.getBoundingClientRect().height);
        }
    }, [data]);

    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start 10%", "end 50%"],
    });

    const heightTransform = useTransform(scrollYProgress, [0, 1], [0, height]);
    const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

    return (
        <div className="w-full relative" ref={containerRef}>
            <div className="mb-12 md:mb-16">
                <motion.h1
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="font-display text-4xl md:text-5xl text-[var(--ink)]"
                >
                    {title || "Hakkımızda"}
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="mt-3 text-[var(--muted)] max-w-xl leading-relaxed"
                >
                    Türkiye'nin dijital spor platformu — Sports Digitale'nin hikâyesi ve vizyonu.
                </motion.p>
            </div>

            <div ref={ref} className="relative pb-8">
                {data.map((item, index) => (
                    <motion.div
                        key={item.title}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.45, delay: index * 0.05 }}
                        viewport={{ once: true, margin: "-40px" }}
                        className="flex gap-6 md:gap-10 pt-10 first:pt-0"
                    >
                        <div className="relative z-10 flex flex-col items-center">
                            <div className="h-8 w-8 border border-[var(--line)] bg-[var(--surface)] flex items-center justify-center text-xs font-semibold text-[var(--accent)]">
                                {String(index + 1).padStart(2, "0")}
                            </div>
                        </div>

                        <div className="flex-1 pb-10 border-b border-[var(--line)] last:border-0">
                            <h3 className="font-display text-2xl md:text-3xl text-[var(--ink)]">
                                {item.title}
                            </h3>
                            <p className="mt-3 text-[var(--muted)] leading-relaxed">
                                {item.content}
                            </p>
                        </div>
                    </motion.div>
                ))}

                <div
                    style={{ height: height + "px" }}
                    className="absolute left-4 top-0 w-px bg-[var(--line)]"
                >
                    <motion.div
                        style={{
                            height: heightTransform,
                            opacity: opacityTransform,
                        }}
                        className="absolute inset-x-0 top-0 w-px bg-[var(--accent)]"
                    />
                </div>
            </div>
        </div>
    );
};

export default Timeline;
